export default "__VITE_ASSET__BCqLmjJV__"